<!--
 Golden Partner Holding Website
 Created by Hu Fang.
 Copyright © GPHolding.ch. All rights reserved.
-->

<script>
  var EnvironmentEnum = {
    QA: "QA",
    STAGE: "STAGE",
    PREPROD: "PREPROD",
    PROD_COTE: "PROD_COTE",
  };

  const ENV = EnvironmentEnum.PROD_COTE;   //switch the environment here.
  const auto_reply = 'true'; //Reply an email after the user saved message on message board.
  // const defaultLocale = 'fr'; //Set Default language in main.js -> defaultLocale
  var BASE_URL = '';
 
  switch (ENV) {
    case EnvironmentEnum.QA: 
      BASE_URL = 'http://localhost:8082';
      break;
    case EnvironmentEnum.STAGE: 
      BASE_URL = 'http://47.103.2.87:8082'; /*not implemented*/
      break;
    case EnvironmentEnum.PROD_COTE: 
      BASE_URL = 'https://www.cote-concierge.ch:8443'; 
      // BASE_URL = 'https://47.91.72.239:8443'; /*https*/
      // BASE_URL = 'http://47.91.72.239:8082';
      //BASE_URL = 'http://localhost:8082'
      break;
    case EnvironmentEnum.PREPROD:
      BASE_URL = 'http://3.124.91.175:8082'; /*not implemented*/
      break;
    default: 
      BASE_URL = 'http://47.91.72.239:8082';
  }
//service path, endpoint path:
  const MESSAGEBOARD_ENDPOINT = '/messageboard/saveMessage?auto_reply=' + auto_reply; 

  const MESSAGEBOARD_CHECKPASSWORD = '/messageboard/checkPassword';
  
  export default{
    BASE_URL,
    MESSAGEBOARD_ENDPOINT,
    MESSAGEBOARD_CHECKPASSWORD,
  }
</script>
